import { startCase } from 'lodash';
import { omitEmptyValues } from '../../../object';

/**
 * Creates a base mixpanel event builder
 *
 * @param {string} [type] - The mixpanel event type.
 * @returns {Function} Builder for an enriched mixpanel event
 */
export const buildMixpanelEvent =
    (type) =>
    (params = {}) => {
        const prettyParams = {};
        Object.keys(params).forEach((key) => {
            const prettyKey = startCase(key);
            prettyParams[prettyKey] = params[key];
        });
        return omitEmptyValues({
            type,
            ...prettyParams,
        });
    };
